import React from 'react';
import { IParsedChartDataRecord } from '../interfaces';
import { LabelProps } from 'recharts';
import { IChartLine } from '../hooks/useChartLines';
import { getValueFromDataPoint } from '../../../utils/redux/util';
import { IBarDimensions, ICustomBarLabel } from '../CustomBarLabel/types';
import { arrangeSingleGroupLabels } from '../CustomBarLabel/arrangeLabels';
import { CustomBarLabel } from '../CustomBarLabel/CustomBarLabel';
import { formatCustomBarLabel } from '../../../utils/formatting';
import {
  IMeasureDisplayFormatFieldsFragment,
  Maybe,
} from '../../../utils/apollo/graphqlSchema';
import isNil from 'lodash/isNil';

export const generateCustomLabels = (
  data: IParsedChartDataRecord[],
  props: LabelProps,
  line: IChartLine,
  measureFormat: Maybe<IMeasureDisplayFormatFieldsFragment>,
) => {
  if (
    // viewBox is not defined
    !props?.viewBox ||
    !('x' in props.viewBox) ||
    // index is not defined
    isNil(props.index) ||
    // index is out of data bounds
    props.index >= data.length
  ) {
    return null;
  }

  const bar: IBarDimensions = {
    x: props.viewBox.x ?? 0,
    y: props.viewBox.y ?? 0,
    width: props.viewBox.width ?? 0,
    height: props.viewBox.height ?? 0,
  };

  if (bar.width < 38) {
    return null;
  }

  const value = getValueFromDataPoint(data[props.index], line.name);
  const valueWithMeasureFormat = formatCustomBarLabel(value, measureFormat);

  const label: ICustomBarLabel = {
    svgProps: {
      fontSize: '11px',
      fontWeight: '600',
    },
    value: valueWithMeasureFormat ?? '',
    insideBarColor: '#fff',
    outsideBarColor: line.color ?? '#000',
  };

  return (
    <>
      {arrangeSingleGroupLabels(bar, [label]).map((pl, i) => (
        <CustomBarLabel key={i} label={pl} opacity={props.opacity} />
      ))}
    </>
  );
};
